import {
  setMessageVisibility,
  getCheckoutCarData,
  getFormValue,
  getOfferFromSelector,
} from 'app/services/businessFunctionHelpers';
import {
  MessagesEnum,
  FormsEnum,
  FieldsEnum,
  InvoiceTypeEnum,
  SteeringWheelLocationEnum,
  PartsTypeEnum,
} from 'app/shared/enums';
import { checkIsDataObfuscated } from 'app/services/businessFunctions/helpers/checkIsDataObfuscated';
import { dispatchThunk } from 'app/store';
import { updateQuotation } from 'app/store/data/quotationConfig';

const carObfuscation = {
  showRegistrationNumberObfuscatedMessage(initialRun?: boolean) {
    const { registrationNumber } = getCheckoutCarData();

    const showObfuscatedMessage = checkIsDataObfuscated(
      registrationNumber,
      initialRun
    );

    setMessageVisibility({
      key: MessagesEnum.RegistrationNumberObfuscated,
      visible: showObfuscatedMessage,
      formName: FormsEnum.CheckoutForm,
    });
  },
  showCarVinObfuscatedMessage(initialRun?: boolean) {
    const { vin } = getCheckoutCarData();

    const showObfuscatedMessage = checkIsDataObfuscated(vin, initialRun);

    setMessageVisibility({
      key: MessagesEnum.CarVinObfuscated,
      visible: showObfuscatedMessage,
      formName: FormsEnum.CheckoutForm,
    });
  },
  checkoutBlockIfDamaged() {
    const damageStatus = getFormValue(
      FieldsEnum.CarDamageStatus,
      FormsEnum.CheckoutForm
    );

    setMessageVisibility({
      key: MessagesEnum.BlockIfDamaged,
      visible: damageStatus === 'damaged',
      formName: FormsEnum.CheckoutForm,
    });
  },
  checkoutBlockIfUSACanadaRegistration() {
    const isImportedFromUsaCanada =
      getFormValue(
        FieldsEnum.CarFirstRegistrationCountry,
        FormsEnum.CheckoutForm
      ) === 'usa_can';

    const offer = getOfferFromSelector();
    const invoiceType = offer?.ac?.invoiceType;
    const hasOriginalParts = offer?.ac?.partsType === PartsTypeEnum.Original;

    const isBlockedRepairScope =
      !!invoiceType?.includes(InvoiceTypeEnum.Aso) ||
      (!!invoiceType?.includes(InvoiceTypeEnum.Workshop) && hasOriginalParts);

    setMessageVisibility({
      key: MessagesEnum.BlockIfUSACanadaRegistration,
      visible: isImportedFromUsaCanada && isBlockedRepairScope,
      formName: FormsEnum.CheckoutForm,
    });
  },
  checkoutBlockIfRightSteeringWheel() {
    const drivingWheelLocation = getFormValue(
      FieldsEnum.CarDrivingWheelLocation,
      FormsEnum.CheckoutForm
    );

    setMessageVisibility({
      key: MessagesEnum.BlockIfRightSteeringWheel,
      visible: drivingWheelLocation === SteeringWheelLocationEnum.Right,
      formName: FormsEnum.CheckoutForm,
    });
  },
  checkoutStoreRightSideSteeringWheel(initialRun?: boolean) {
    if (initialRun) {
      return;
    }

    const drivingWheelLocation = getFormValue(
      FieldsEnum.CarDrivingWheelLocation,
      FormsEnum.CheckoutForm
    );

    dispatchThunk(
      updateQuotation(
        FieldsEnum.CarRightSideSteeringWheel,
        drivingWheelLocation === SteeringWheelLocationEnum.Right
      )
    );
  },
};

export default carObfuscation;
